export function getDaysDifference(startDateStr:string|Date, endDateStr:string) {
    const createdOn = new Date(startDateStr);
    const deadline = new Date(endDateStr);
    
    // Calculate the difference in milliseconds
    const differenceInMilliseconds = deadline.getTime() - createdOn.getTime();
    
    // Convert milliseconds to days
    const millisecondsInADay = 24 * 60 * 60 * 1000;
    const differenceInDays = differenceInMilliseconds / millisecondsInADay;

    const roundDiff = Math.round(differenceInDays * 10) / 10;
    return roundDiff;
  }
  